/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {$insertNodeToNearestRoot} from '@lexical/utils';
import {$createKalturaNode, KalturaNode} from 'components/DSYS/editor/nodes/KalturaNode';
import {COMMAND_PRIORITY_EDITOR, createCommand, LexicalCommand} from 'lexical';
import {useEffect} from 'react';

export const INSERT_KALTURA_COMMAND: LexicalCommand<string> =
  createCommand('INSERT_KALTURA_COMMAND');

export const KalturaPlugin = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (!editor.hasNodes([KalturaNode])) {
      throw new Error('KalturaPlugin: KalturaNode not registered on editor');
    }

    return editor.registerCommand<string>(
      INSERT_KALTURA_COMMAND,
      (payload) => {
        const youTubeNode = $createKalturaNode(payload);
        $insertNodeToNearestRoot(youTubeNode);

        return true;
      },
      COMMAND_PRIORITY_EDITOR
    );
  }, [editor]);

  return null;
};
